import { useSearchParams } from '@remix-run/react';

import { Button } from '~/components/ui/Button';

type DemoBannerProps = {
  isDemoSession: boolean;
};

export function DemoBanner({ isDemoSession }: DemoBannerProps) {
  const [, setSearchParams] = useSearchParams();

  if (!isDemoSession) {
    return null;
  }

  return (
    <div className="w-full shrink-0 bg-amber-50 border-b border-amber-200 px-4 py-2.5 text-sm text-amber-900 flex flex-wrap items-center justify-between gap-3">
      <div>
        <span className="font-semibold">Demo mode</span>
        <span className="mx-2 text-amber-700">·</span>
        <span>Read-only sandbox with fictional data. Changes are disabled.</span>
      </div>
      <Button
        type="button"
        variant="secondary"
        className="text-xs py-1 px-3 h-auto"
        onClick={() => {
          const next = new URLSearchParams(window.location.search);
          next.set('tour', '1');
          setSearchParams(next);
        }}
      >
        Restart tour
      </Button>
    </div>
  );
}
